import React, { useEffect, useState } from "react";
import { Spin, message } from "antd";
import axios from "axios";

const ChannexIframePage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchIframeUrl = async () => {
      try {
        setLoading(true);

        const res = await axios.post(
          `${apiUrl}/channels/iframe-token`,
          {
            provider_code: "channex",
            redirect_to: "/channels",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const url = res?.data?.iframe_url;

        if (!url) {
          throw new Error("iframe_url not returned from API");
        }

        if (isMounted) {
          setIframeUrl(url);
        }
      } catch (error) {
        console.error("Error loading Channex iframe:", error?.response?.data || error.message);
        message.error(
          error?.response?.data?.message || "Failed to load Channex dashboard."
        );
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (!apiUrl) {
      message.error("Missing REACT_APP_API_URL.");
      setLoading(false);
      return;
    }

    if (!token) {
      message.error("Missing login token.");
      setLoading(false);
      return;
    }

    fetchIframeUrl();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, token]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Spin size="large" tip="Loading Channex Dashboard..." />
      </div>
    );
  }

  if (!iframeUrl) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          textAlign: "center",
        }}
      >
        <div>Unable to load Channex dashboard.</div>
      </div>
    );
  }

  return (
    <div className="page-wrapper-full">
      <div className="content container-fluid" style={{ padding: 0 }}>
        <iframe
          src={iframeUrl}
          title="Channex Channel Manager"
          width="100%"
          height="100%"
          style={{
            border: "none",
            width: "100%",
            minHeight: "100vh",
          }}
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default ChannexIframePage;